import { create } from "zustand";
import { feedbackIntegration } from "@sentry/react";
type Feedback = ReturnType<typeof feedbackIntegration>;

interface SentryState {
  feedback?: Feedback;
}

export const useSentryStore = create<SentryState>(() => ({
  feedback: undefined,
}));
